import React from 'react';
import { connect } from 'react-redux';
import './signin.scss';
import {
  FormField,
  Input,
  InputLabel,
  SectionBody,
} from 'aws-amplify-react/lib/Amplify-UI/Amplify-UI-Components-React';
import warning from '../../static/images/mvp/warning.png';
import { CustomMenuItem, CustomSelect, CustomSelectComponent, formTheme } from './ThemeSignIn';
import { I18n } from '../../helpers/i18n';

class SignUpBuddyInfo extends React.Component {
  constructor(props) {
    super(props);
    this.inputs = {};
    this.state = {};

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleSelectCommunity = (event) => {
    this.props.onSelectCommunity(event.target.value);
  };

  handleInputChange(evt) {
    this.inputs = this.inputs || {};
    const { name, value, type, checked } = evt.target;
    const check_type = ['radio', 'checkbox'].includes(type);
    this.inputs[name] = check_type ? checked : value;
    this.inputs['checkedValue'] = check_type ? value : null;
    this.props.onInputChange(evt);
  }

  render() {
    const {
      errorEmail,
      errorName,
      errorPassword,
      errorRePassword,
      youthCommunity,
      listBuddyYouthCommunity,
      email,
      rePassword,
      password,
      name
    } = this.props;
    const theme = {
      color: '#000000',
      fontSize: '16px',
      lineHeight: '24px',
      borderColor: '#CCCCCC',
      borderRadius: '4px',
      padding: '14px 16px',
    };

    return (
      <SectionBody theme={formTheme}>
        <FormField theme={formTheme}>
          <InputLabel theme={formTheme}>{I18n.t('senior_account_account_info_email_label')} <span className="text-danger">*</span></InputLabel>
          <Input
            autoFocus
            placeholder={I18n.t('email_hint_text')}
            key="email"
            name="email"
            value={email}
            onChange={this.handleInputChange}
            theme={{ input: { ...theme, borderColor: errorEmail ? '#FF445D' : '#cccccc' } }}
          />
          {errorEmail && (
            <span className="error-message">
                    <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
              {errorEmail}
                  </span>
          )}
        </FormField>
        <FormField theme={formTheme}>
          <InputLabel theme={formTheme}>{I18n.t('name_hint_text')} <span className="text-danger">*</span></InputLabel>
          <Input
            placeholder={I18n.t('name_hint_text')}
            key="name"
            name="name"
            value={name}
            onChange={this.handleInputChange}
            theme={{ input: { ...theme, borderColor: errorName ? '#FF445D' : '#cccccc' } }}
          />
          {errorName && (
            <span className="error-message">
                    <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
              {errorName}
                  </span>
          )}
        </FormField>
        <FormField theme={formTheme}>
          <InputLabel theme={formTheme}>{I18n.t('password')} <span className="text-danger">*</span></InputLabel>
          <Input
            placeholder={I18n.t('password_hint')}
            key="password"
            name="password"
            type="password"
            value={password}
            onChange={this.handleInputChange}
            theme={{ input: { ...theme, borderColor: errorPassword ? '#FF445D' : '#cccccc' } }}
            autoComplete="off"
          />
          {errorPassword && (
            <span className="error-message">
                    <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
              {errorPassword}
                  </span>
          )}
        </FormField>
        <FormField theme={formTheme}>
          <InputLabel theme={formTheme}>{I18n.t('repeat_password_hint_text')} <span
            className="text-danger">*</span></InputLabel>
          <Input
            placeholder={I18n.t('password_hint')}
            key="rePassword"
            name="rePassword"
            type="password"
            value={rePassword}
            onChange={this.handleInputChange}
            autoComplete="off"
            theme={{ input: { ...theme, borderColor: errorRePassword ? '#FF445D' : '#cccccc' } }}
          />
          {errorRePassword && (
            <span className="error-message">
                    <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
              {errorRePassword}
                  </span>
          )}
        </FormField>
        <CustomSelectComponent
          placeholder={I18n.t('youth_community')}
          title={I18n.t('youth_community')}
          required={true}
          options={listBuddyYouthCommunity}
          selectedValue={youthCommunity}
          onChange={this.handleSelectCommunity}
        ></CustomSelectComponent>
      </SectionBody>
    );
  };
}

const mapStateToProps = ({ user }) => ({
  userInfo: user,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SignUpBuddyInfo);
